import React, { useState } from "react";
import Display from "./content";


function Create(props){
    
    const [expand,setexpand] = useState(false);

    function isexpand(){
        setexpand(true);
    }

    
    const [note,setNote]=useState({
        title:"",
     content: ""
    });


    function handlechange(event){
        const {name,value}= event.target;

        setNote ( prevNote =>{
          return{ ...prevNote,
            [name]:value
        };
     }
    );
    }

    

    function submit(event)
    {
     setexpand(false);
     if(note.title.length == 0 )
     {
       window.alert("Your Note Is Empty, Please Add Content :) ");
     }
     else
     {
     props.onAdd(note);
     setNote(
         {
             title: "",
             content: ""
         }
        );
        
     event.preventDefault();  
        }
    }

return( 
    <div>
    
    <form className="note-form" id="formblur" >
   
       
       {
           expand && (  <input className="ntitle"
            name="title" value={note.title}
            onChange={handlechange} 
            placeholder="Title..." 
            required />
    
       )}
       <textarea
            rows={expand ? 8 : 3}
            cols="30" 
            className="ncontent" 
            name="content" 
            value={note.content} 
          onChange={handlechange} 
          placeholder="Take a note..."
          webkit-input-placeholder="Take a note..."
          onClick={isexpand} 
          required>
       </textarea>
       <a className="plus-button" onClick={submit}><img src="../images/plus-circle.svg"></img></a>
      
       
    </form>
    </div>
);
}

export default Create;